export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12085.b9ecb2fa.jpg";